
import { Component, Inject, Vue, Emit } from "vue-property-decorator";
import { EventTopic, EventType } from "@gsx/common";
import { Container } from "inversify";
import { ConferenceFilterStore } from "../../stores/conference/ConferenceFilterStore";
import CategoryFilterGroup from "../organization/CategoryFilterGroup.vue";
import slugify from "slugify";
import { ConferenceListStore } from "../../stores/conference/ConferenceListStore";
import { SelectOption } from "../../../../landing/src/molecules/form/types";
import countries, { ICountry, ICity, IState } from "../../../../vendor/country-state-city";
import CountryFilter from "../sidebars/filters/CountryFilter.vue";
import { handleError } from "../../../../common/src/utility/errorUtils";

@Component({
    components: { CategoryFilterGroup, CountryFilter },
})
export default class CategoriesFilter extends Vue {
    @Inject("container") container!: Container;
    filterStore: ConferenceFilterStore = this.container.get(ConferenceFilterStore);
    listStore: ConferenceListStore = this.container.get("ConferenceCategoryListStore");

    created() {
        this.listStore.afterDate = new Date();
        this.listStore.pageSize = Number.MAX_SAFE_INTEGER;

        this.listStore.load().catch(handleError);
    }

    get topics(): EventTopic[] {
        return Object.values(EventTopic);
    }

    get types(): EventType[] {
        return Object.values(EventType);
    }

    get countries(): ICountry[] {
        return countries
            .getAllCountries()
            .filter((country) =>
                this.listStore.items?.some((event) => event.country === country.name),
            );
    }

    get states(): IState[] {
        let statesFromCountries: IState[] = [];
        this.countries.forEach((country) => {
            let states = countries.getStatesOfCountry(country.id);
            statesFromCountries = statesFromCountries.concat(
                states.filter((state) =>
                    this.listStore.items?.some(
                        (event) => event.state === state.name && event.country === country.name,
                    ),
                ),
            );
        });
        return statesFromCountries;
    }

    get cities(): ICity[] {
        let citiesFromStates: ICity[] = [];
        this.states.forEach((state) => {
            let cities = countries.getCitiesOfState(state.id);
            citiesFromStates = citiesFromStates.concat(
                cities.filter((city) =>
                    this.listStore.items?.some(
                        (event) => event.city === city.name && event.state === state.name,
                    ),
                ),
            );
        });
        return citiesFromStates.sort((a, b) => (b.name > a.name ? -1 : 1));
    }

    get eventOptions(): SelectOption[] {
        return this.listStore.items!.map((item) => ({
            id: item.conferenceid,
            name: item.name,
        }));
    }

    updateEventFilter(query: string) {
        this.filterStore.search = query;
    }

    @Emit("eventClick")
    handleEventClick(option: SelectOption) {
        return { event: { id: option.id } };
    }

    topicId(topic: EventTopic) {
        return `topic_${slugify(topic)}`;
    }

    typeId(type: EventType) {
        return `type_${slugify(type)}`;
    }
}
